export { default } from './BlogInfo.component';
